<template>
  <div class="container admin-page-with-back-py">
    <div class="mb-2">
      <a class="back-button" :href="route('team-members.report.summary')">
        <BackIcon/>
        Back to Task Report
      </a>
    </div>

    <div class="row">
      <div class="col-12 col-lg-8 offset-lg-2">
        <div class="row mb-5">
          <div class="col-12 text-center">
            <div class="page-title">Hours Spent</div>
            <div class="hrs-spent">{{ totalTimeSpent }}</div>
            <div class="stat-unit">In total</div>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <tab-navigation
                :tabs="tabs"
                :currentTab="currentTab"
                @tabSelected="activeTab => this.currentTab = activeTab"
            ></tab-navigation>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <staff-tasks v-if="currentTab === 'all'" key="all_tasks"></staff-tasks>
            <staff-tasks status="completed" v-if="currentTab === 'completed'" key="completed_tasks"></staff-tasks>
            <staff-tasks status="incomplete" v-if="currentTab === 'incomplete'" key="incomplete_tasks"></staff-tasks>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackIcon from '@icons/BackIcon';

export default {
  components: { BackIcon },
  props: {
    tab: {
      required: false,
      default: 'all',
    },
  },

  data () {
    return {
      tabs: [
        {
          title: 'All',
          key: 'all',
        },
        {
          title: 'Completed',
          key: 'completed',
        },
        {
          title: 'Incomplete',
          key: 'incomplete',
        },
      ],
      currentTab: this.tab,
    };
  },

  computed: {
    totalTimeSpent () {
      return localStorage.getItem('wfh_tts') ?? '';
    },
  },
};
</script>

<style scoped>
.hrs-spent {
  color: #222227;
  font-family: "Open Sans", sans-serif;
  font-size: 52px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 55px;
  text-align: center;
}
</style>
